import React from "react";
import { FaMoon, FaSun } from "react-icons/fa";
import useChangeTheme from "../../../shared/hooks/useChangeTheme";
import "./switch.scss";

const Switch = () => {
  const [isDark, changeDarkMode] = useChangeTheme();
  const compClass = "a-switch";
  return (
    <div className={compClass} onClick={changeDarkMode}>
      <FaMoon className="hide-mobile icon" />
      <div className={`${compClass}__container`}>
        <div
          className={`${compClass}__container__circle ${compClass}__container__circle${
            isDark ? "-dark" : "-light"
          }`}
        ></div>
      </div>
    </div>
  );
};

export default Switch;
